import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiUrl, getDecodedCookie } from '../../helpers/helperApp';
import swal from 'sweetalert';


function MaintenanceTableEquiposl({ equipmentId, loading, ViewMaintenance}) {

    const [ maintenanceData, setMaintenanceData ] = useState([]);
    const [ loadingData, setLoadingData ]         = useState(false);
    const [ sortField, setSortField ]             = useState(null);
    const [ sortDir, setSortDir ]                 = useState('asc');
    const [ search, setSearch ]                   = useState('');
    const [loadingPdf, setLoadingPdf] = useState(null);
    

    useEffect(() => {
        if( equipmentId && equipmentId != 0 ){
            fetchMaintenanceData();
        }
    }, [equipmentId]);

    const fetchMaintenanceData = async () => {
        setLoadingData(true);
        try {
            const validacion = {
                id:     getDecodedCookie('id'),
                sesion: getDecodedCookie('sesion')
            };
            const data = new FormData();
            data.append("validacion", JSON.stringify(validacion));
            data.append("id", equipmentId);

            const url      = `${getApiUrl(window.location.origin)}/equipos/getEquipmentMaintenance`;
            const response = await axios.post(url, data);
            setMaintenanceData(response.data || []);
        } catch (error) {
            console.error('Error fetching maintenance data:', error);
            setMaintenanceData([]);
        } finally {
            setLoadingData(false);
        }
    };

    const handleSort = (field) => {
        if( sortField === field ){
            setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDir('asc');
        }
    };

    const getSortIcon = (field) => {
        if( sortField !== field ) return <i className="fal fa-sort ml-1 text-muted" style={{fontSize:'0.7rem'}}></i>;
        return sortDir === 'asc'
            ? <i className="fal fa-sort-up ml-1" style={{fontSize:'0.7rem'}}></i>
            : <i className="fal fa-sort-down ml-1" style={{fontSize:'0.7rem'}}></i>;
    };

    const filteredData = maintenanceData
        .filter(row =>
            Object.values(row).some(val =>
                String(val).toLowerCase().includes(search.toLowerCase())
            )
        )
        .sort((a, b) => {
            if( !sortField ) return 0;
            const valA = String(a[sortField] || '').toLowerCase();
            const valB = String(b[sortField] || '').toLowerCase();
            return sortDir === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
        });

    const handlePrintPDF = async (idDoc) => {
        setLoadingPdf(idDoc);
        try {
            const url = `/reports/generarInforme?usuactual=${getDecodedCookie('id')}&sesion=${getDecodedCookie('sesion')}&idinf=80&idreg=${idDoc}&asunto=&cuerpo=&destinatarios=`;
            const respuesta = await axios.get(getApiUrl(window.location.origin) + url);
            if (respuesta.data.url) {
                window.open(respuesta.data.url, '_blank');
            }
            if (respuesta.data.error) {
                swal("Error", respuesta.data.error, "error");
            }
        } catch (error) {
            console.error('Error generando PDF:', error);
            swal("Error", "No se pudo generar el PDF.", "error");
        } finally {
            setLoadingPdf(null);
        }
    };    
        

    const styles = {
        wrapper: {
            background: '#f8f9fc',
            borderRadius: '10px',
            padding: '20px',
            marginTop: '16px',
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)'
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '16px',
            flexWrap: 'wrap',
            gap: '10px'
        },
        title: {
            fontSize: '1rem',
            fontWeight: '600',
            color: '#2d3748',
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
        },
        badge: {
            background: '#667eea',
            color: '#fff',
            borderRadius: '12px',
            padding: '2px 10px',
            fontSize: '0.75rem',
            fontWeight: '600'
        },
        searchInput: {
            border: '1px solid #e2e8f0',
            borderRadius: '6px',
            padding: '6px 12px',
            fontSize: '0.85rem',
            outline: 'none',
            width: '220px',
            background: '#fff'
        },
        table: {
            width: '100%',
            borderCollapse: 'separate',
            borderSpacing: 0,
            fontSize: '0.875rem'
        },
        th: {
            background: '#2d3748',
            color: '#e2e8f0',
            padding: '10px 14px',
            fontWeight: '600',
            fontSize: '0.78rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            userSelect: 'none',
            borderBottom: '2px solid #4a5568'
        },
        thFirst: { borderTopLeftRadius: '8px' },
        thLast:  { borderTopRightRadius: '8px' },
        td: {
            padding: '10px 14px',
            borderBottom: '1px solid #edf2f7',
            color: '#4a5568',
            verticalAlign: 'middle'
        },
        trEven: { background: '#fff' },
        trOdd:  { background: '#f7fafc' },
        codBadge: {
            background: '#ebf4ff',
            color: '#3182ce',
            borderRadius: '4px',
            padding: '2px 8px',
            fontSize: '0.78rem',
            fontWeight: '600',
            fontFamily: 'monospace'
        },
        idBadge: {
            background: '#f0fff4',
            color: '#38a169',
            borderRadius: '4px',
            padding: '2px 8px',
            fontSize: '0.78rem',
            fontWeight: '600',
            fontFamily: 'monospace'
        },
        dateBadge: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '5px',
            background: '#faf5ff',
            color: '#805ad5',
            borderRadius: '4px',
            padding: '2px 8px',
            fontSize: '0.78rem',
            fontWeight: '500'
        },
        hoursCell: {
            fontWeight: '600',
            color: '#e53e3e'
        },
        noData: {
            textAlign: 'center',
            padding: '40px',
            color: '#a0aec0',
            fontSize: '0.9rem'
        },
        actionButton: {
        padding: '3% 6%',
        borderRadius: '6px',
        border: 'none',
        backgroundColor: '#4f46e5',
        color: '#fff',
        cursor: 'pointer',
        fontSize: '0.95rem',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '2%',
        }
    };

    if( loading || loadingData ){
        return (
            <div style={{...styles.wrapper, textAlign:'center', padding:'40px'}}>
                <i className="fal fa-spinner fa-spin mr-2" style={{color:'#667eea', fontSize:'1.2rem'}}></i>
                <span style={{color:'#718096'}}>Cargando mantenimientos...</span>
            </div>
        );
    }

    if( !equipmentId || equipmentId == 0 ){
        return (
            <div style={{...styles.wrapper, textAlign:'center', padding:'40px'}}>
                <i className="fal fa-tools" style={{fontSize:'2rem', color:'#cbd5e0', display:'block', marginBottom:'10px'}}></i>
                <span style={{color:'#a0aec0'}}>Seleccione un equipo para ver sus mantenimientos.</span>
            </div>
        );
    }

    return (
        <div style={styles.wrapper}>
            {/* Header */}
            <div style={styles.header}>
                <h6 style={styles.title}>
                    <i className="fal fa-tools" style={{color:'#667eea'}}></i>
                    Mantenimientos
                    <span style={styles.badge}>{ filteredData.length }</span>
                </h6>
                <input
                    type="text"
                    placeholder="🔍  Buscar..."
                    style={styles.searchInput}
                    value={search}
                    onChange={ e => setSearch(e.target.value) }
                />
            </div>

            {/* Table */}
            <div style={{overflowX:'auto', borderRadius:'8px', border:'1px solid #e2e8f0'}}>
                <table style={styles.table}>
                    <thead>
                        <tr>
                            {[                            
                                { label: 'Equipo',      field: 'equipment' },
                                { label: 'Descripción', field: 'maintenance_description' },
                                { label: 'Fecha',       field: 'date' }
                            ].map((col, i, arr) => (
                                <th
                                    key={col.field}
                                    style={{
                                        ...styles.th,
                                        ...(i === 0 ? styles.thFirst : {}),
                                        
                                    }}
                                    onClick={ () => handleSort(col.field) }
                                >
                                    {col.label} {getSortIcon(col.field)}
                                </th>
                            ))}
                              {/*   <th style={{ ...styles.th, ...styles.thLast, textAlign: 'center' }}>
                                    Acciones
                                </th> */}
                        </tr>
                    </thead>
                    <tbody>
                        { filteredData.length === 0
                            ? (
                                <tr>
                                    <td colSpan="6" style={styles.noData}>
                                        <i className="fal fa-inbox" style={{fontSize:'1.5rem', display:'block', marginBottom:'8px'}}></i>
                                        No hay mantenimientos registrados para este equipo.
                                    </td>
                                </tr>
                            )
                            : filteredData.map((row, index) => (
                                <tr 
                                    key={ row.id_doc || index } 
                                    style={{ 
                                        ...( index % 2 === 0 ? styles.trEven : styles.trOdd ),
                                        cursor: 'pointer'
                                    }}
                                    //onClick={ () => ViewMaintenance(row.id_doc) }
                                >
                                    <td style={styles.td}>{ row.equipment }</td>
                                    <td style={styles.td}>{ row.maintenance_description }</td>
                                    <td style={styles.td}>
                                        <span style={styles.dateBadge}>
                                            <i className="fal fa-calendar-alt"></i>
                                            { row.date }
                                        </span>
                                    </td>
                                  {/*   <td style={{ ...styles.td, textAlign: 'center', cursor: 'default' }}
                                       onClick={(e) => e.stopPropagation()}
                                    >
                                         <button
                                            style={{
                                                ...styles.actionButton,
                                                ...(loadingPdf === row.id_doc ? { backgroundColor: '#818cf8', cursor: 'not-allowed' } : {})
                                            }}
                                            disabled={loadingPdf === row.id_doc}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handlePrintPDF(row.id_doc);
                                            }}
                                        >
                                            {loadingPdf === row.id_doc
                                                ? <i className="fal fa-spinner fa-spin"></i>
                                                : <i className="fal fa-print"></i>
                                            }
                                        </button>
                                    </td> */}
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default MaintenanceTableEquiposl;